import { render, staticRenderFns } from "./Chevron.vue?vue&type=template&id=86b3c6b0&scoped=true"
import script from "./Chevron.vue?vue&type=script&lang=ts"
export * from "./Chevron.vue?vue&type=script&lang=ts"
import style0 from "./Chevron.vue?vue&type=style&index=0&id=86b3c6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b3c6b0",
  null
  
)

export default component.exports